import axios from 'axios';
import { backendURL } from './consts';

export const loginAdmin = async (data) => {
  const res = await axios.post(
    `${backendURL}/auth/login`,
    data
  );
  return res.data;
}

export const authAdmin = async (token) => {
  const res = await axios.get(
    `${backendURL}/auth/`,
    {
      headers:{
        token:`bearer ${token}`
      }
    }
  );
  return res.data;
}

export const validateAuthToken = async (data) => {
  const res = await axios.post(
    `${backendURL}/auth/validate`,
    data
  );
  return res.data;
}